const routes = [
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/modules/settings/pages/Entry.vue'),
    meta: {
      metaTags: [
        {
          page_slug: 'settings',
        },
        {
          name: 'description',
          content: 'Great tools to help you grow your Etsy shop into a thriving business.',
        },
        {
          name: "google",
          content: "notranslate",
        },
      ],
      requiresAuth: true,
      title: 'eRank — Settings',
    },
  },
  {
    path: '/settings/confirm-email',
    name: 'settings.confirm-email',
    component: () => import('@/modules/settings/pages/ConfirmEmail.vue'),
    meta: {
      metaTags: [
        {
          name: 'description',
          content: 'Great tools to help you grow your Etsy shop into a thriving business.',
        },
        {
          name: "google",
          content: "notranslate",
        },
      ],
      requiresAuth: true,
      title: 'eRank — Settings',
    },
  },
];

export default routes;
  